(() => {
  angular
    .module('gm.common.directives')
    .directive('gmCsvButton', gmCsvButtonDirective);

  function gmCsvButtonDirective(
    $document
  ) {
    'ngInject';

    function exportCSV(attrs) {
      const elm = $document[0].getElementById(attrs.element);
      const table = angular.element(elm);
      const data = tableToCSV(table);
      const link = $document[0].createElement('a');

      link.download = attrs.filename;
      link.href = `data:,${escape(data)}`;
      link.click();
    }

    function mapText(elm) {
      const arr = [];

      angular.forEach(elm, (val) => {
        const td = angular.element(val);

        if (td.attr('data-csv-export') !== 'false') {
          let text = td.text().trim();

          text = text.replace(/\s+/g, ' ');
          arr.push(`"${text}"`);
        }
      });
      return arr;
    }

    function tableToCSV(table) {
      const th = table.find('thead').find('th');
      const rows = table.find('tbody').find('tr');
      let data = `${mapText(th).join(',')}\n`;

      angular.forEach(rows, (row) => {
        const tr = angular.element(row);

        if (tr.attr('data-csv-export') !== 'false') {
          const td = tr.find('td');

          data += `${mapText(td).join(',')}\n`;
        }
      });
      return data;
    }

    return {
      restrict: 'E',
      scope: {
        text: '=?'
      },
      templateUrl: 'modules/common/directives/csv-button/csv-button.html',
      transclude: true,

      link(scope, element, attrs) {
        element.on('click', () => {
          if (attrs.load) {
            scope.$eval(attrs.load, {
              callback: exportCSV
            });
          } else {
            exportCSV(attrs);
          }
        });
      },
    };
  }
})();
